var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3603 11.2997C10.6532 11.5926 10.6532 12.0674 10.3603 12.3603L7.53029 15.1903C7.23739 15.4832 6.76252 15.4832 6.46963 15.1903C6.17673 14.8974 6.17673 14.4226 6.46963 14.1297L8.7693 11.83L6.46963 9.53033C6.17673 9.23744 6.17673 8.76256 6.46963 8.46967C6.76252 8.17678 7.23739 8.17678 7.53029 8.46967L10.3603 11.2997Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1904 8.46967C17.4833 8.76256 17.4833 9.23744 17.1904 9.53033L14.8907 11.83L17.1904 14.1297C17.4833 14.4226 17.4833 14.8974 17.1904 15.1903C16.8975 15.4832 16.4226 15.4832 16.1297 15.1903L13.2997 12.3603C13.0068 12.0674 13.0068 11.5926 13.2997 11.2997L16.1297 8.46967C16.4226 8.17678 16.8975 8.17678 17.1904 8.46967Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.23d53c47.svg";
export { ForwardRef as ReactComponent };